import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BancoContaRequest, BancoContaResponse } from './banco-conta.model';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '../../../../../../../environments/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class BancoContaService extends BaseService {
    readonly PATH = SICOM_PATHS.financeiro.arrecadacao.bancoConta;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    listarPorBanco(codigoBanco: string): Observable<BancoContaResponse[]> {
        return this.http.get<BancoContaResponse[]>(this.PATH, { params: { codigoBanco } });
    }

    salvar(request: BancoContaRequest): Observable<BancoContaResponse> {
        return this.http.post<BancoContaResponse>(this.PATH, request);
    }

    deletar(id: number): Observable<void> {
        return this.http.delete<void>(`${this.PATH}/${id}`);
    }
}
